import React from 'react';
import PropTypes from 'prop-types';

import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LogarithmicScale,
  LineElement
} from 'chart.js';

ChartJS.register(
  PointElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  LogarithmicScale
);


import { Bar } from 'react-chartjs-2';

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  makeStyles,
  colors
} from '@material-ui/core';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const useStyles = makeStyles(() => ({
  root: {}
}));

const Latest = ({ className, ...rest }) => {
  const classes = useStyles();
  const theme = useTheme();

  const data = {
    datasets: [
      {
        backgroundColor: colors.red[600],
        data: rest.distribution.news,
        label: 'Novos'
      },
      {
        backgroundColor: colors.yellow[500],
        data: rest.distribution.solving,
        label: 'Em Tratamento'
      },
      {
        backgroundColor: colors.green[600],
        data: rest.distribution.resolveds,
        label: 'Resolvidos'
      }
    ],
    labels: rest.distribution.dates
  };

  var options1 = {
    maintainAspectRatio: false,
    responsive: true,
    resizeDelay: 300,
    elements: {
      bar: {
        borderRadius: 2,
        borderWidth: 1
      },
    },
    plugins: {
      datalabels: {
        display: function (context) {
          var index = context.dataIndex;
          var value = context.dataset.data[index];
          return value > 0;
        },
        color: "black",
        formatter: Math.round,
        anchor: "center",
        offset: 10,
        align: "center"
      },
      legend: {
        display: true
      }
    },
    scales: {
      x: {
      },
      y: {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0,
          precision: 0
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider
        }
      }
    }
  };

  const options = {
    animation: false,
    cornerRadius: 5,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          barThickness: 15,
          maxBarThickness: 15,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: theme.palette.text.secondary,
            precision: 0
          },
          gridLines: {
            display: true,
            drawBorder: true
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0,
            precision: 0
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          }
        }
      ]
    },
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  return (
    <Card
      className={classes.root}
      {...rest}
    >
      <CardHeader
        action={(
          <Button
            endIcon={<ArrowDropDownIcon />}
            size="small"
            variant="text"
          >
            7 Dias
          </Button>
        )}
        title="Últimos Alarmes Registrados"
      />
      <Divider />
      <CardContent>
        <Box
          height={400}
          position="relative"
        >
          <Bar
            data={data}
            options={options1}
          />
        </Box>
      </CardContent>
      <Divider />
      <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Button
          color="secondary"
          endIcon={<ArrowRightIcon />}
          size="small"
          variant="text"
          href="/mon/history"
        >
          Detalhes
        </Button>
      </Box>
    </Card>
  );
};

Latest.propTypes = {
  className: PropTypes.string
};

export default Latest;
